var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheck3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "#00DA99",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5255 4.46491C13.8211 4.75516 13.8253 5.23001 13.5351 5.52553L6.66009 12.5255C6.51907 12.6691 6.32625 12.75 6.125 12.75C5.92375 12.75 5.73093 12.6691 5.58991 12.5255L2.46491 9.34371C2.17467 9.04819 2.17895 8.57334 2.47447 8.2831C2.76999 7.99285 3.24484 7.99713 3.53509 8.29265L6.125 10.9297L12.4649 4.47447C12.7552 4.17895 13.23 4.17467 13.5255 4.46491Z",
    fill: "#00DA99"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck3);
export default __webpack_public_path__ + "static/media/check3.48824cffe67d7c1fe07089a1efcd5ea2.svg";
export { ForwardRef as ReactComponent };